import { ElementWithProperties } from "../ElementWithProperties";
import { PropertyType } from "../enums/PropertyType";

export const hasProperty = (element: ElementWithProperties, key: PropertyType) => {
    if (!element || !element.properties) return false;
    return element.properties[PropertyType[key]] !== undefined;
};

export const getPropertyString = (
    element: ElementWithProperties,
    key: PropertyType,
    defaultValue?: string,
) => (hasProperty(element, key) ? element.properties[PropertyType[key]] : defaultValue);

export const getPropertyNumber = (
    element: ElementWithProperties,
    key: PropertyType,
    defaultValue?: number,
) => Number(element.properties[PropertyType[key]]) || defaultValue;

export const getPropertyBoolean = (
    element: ElementWithProperties,
    key: PropertyType,
    trueValue?: string,
): boolean => {
    if (trueValue === undefined)
        return getPropertyBoolean(element, key, "Yes") || getPropertyBoolean(element, key, "True");
    return String(element.properties[PropertyType[key]]).toUpperCase() === trueValue.toUpperCase();
};

export const getPropertyEnum = (element: ElementWithProperties, e: any, key: PropertyType) =>
    e[String(element.properties[PropertyType[key]])];
